/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $('.quantity-minus').on('click', function(){
          $this = $(this);
          $prev_val = $this.parent().find('.input-text').val();
          if($prev_val >= 2) {
            $this.parent().find('.input-text').val(parseInt($prev_val) - 1);
          }
        });
        
        $('.quantity-plus').on('click', function(){
          $this = $(this);
          $prev_val = $this.parent().find('.input-text').val();
          $this.parent().find('.input-text').val(parseInt($prev_val) + 1);
        });
        
        
        
        
        var $main_menu = $(".nav-wrapper");

        $(document).on('click', '.menu-toggle', function(){

            $main_menu.fadeToggle();

            $('body').toggleClass('menu-scroll-fix');

            $(this).find('i').toggleClass('fa-bars fa-times').hide().fadeIn();

            $(this).attr('aria-expanded', function (i, attr) {
                return attr === 'true' ? 'false' : 'true';
            });
        });

        $(window).on('resize', function(){
            if(window.innerWidth > 768) {
                $main_menu.show();
            }
        });
        
        
        
        
        
        
        
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $("#slider").lightSlider({
          item: 1,
          gallery: true,
          thumbItem: 4
        });
        
        var picker = new Pikaday({ 
          field: document.getElementById('datepicker'),
          format: 'D.MM.YYYY',
          firstDay: 1,
          minDate: new Date(),
          i18n: {
            previousMonth : 'Poprzedni miesiąc',
            nextMonth     : 'Następny miesiąc',
            months        : ['Styczeń','Luty','Marzec','Kwiecień','Maj','Czerwiec','Lipiec','Sierpnień','Wrzesień','Październik','Listopad','Grudzień'],
            weekdays      : ['Niedziela','Poniedziałek','Wtorek','Środa','Czwartek','Piątek','Sobota'],
            weekdaysShort : ['Nie','Pon','Wt','Śr','Czw','Pt','Sob']
          }
        });
        
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        
        $(".home-slider").lightSlider({
          item: 1,
          pager: false,
          controls: false,
          mode: 'fade',
          auto: true,
          loop: true,
          pause: 5000,
          onBeforeSlide: function(el) {
            if(!el.find('.active').prev().hasClass('left')) {
              $('.slide-wrapper').addClass('right').removeClass('left');
            } else {
              $('.slide-wrapper').addClass('left').removeClass('right');
            }
          }
        });

        
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
